import React from 'react'

import FormHelperText from '@material-ui/core/FormHelperText'

/* modules */
import Feeds from './feeds_translation'
/* modules */

const Invalid = ({ error, translation }) => {
  if (!error) return null
  const feedData = { error, translation }
  console.log(feedData)
  return (
    <FormHelperText error>
      <Feeds {...feedData} />
    </FormHelperText>
  )
}

export default Invalid
